export enum MigrationStep {
  CUSTOMER = 'CUSTOMER',
  TRUCKING_COMPANY = 'TRUCKING_COMPANY',
  BOOKING = 'BOOKING',
  ACTIVE_UNIT = 'ACTIVE_UNIT',
  CONTRACT = 'CONTRACT',
  REDELIVERY = 'REDELIVERY'
}

export type StepStatus = 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED' | 'CANCELLED' | 'PARTIALLY_COMPLETED';

export type OverallStatus = 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED' | 'ROLLED_BACK' | 'CANCELLED';

export interface MigrationError {
  rowNumber: number;
  message: string;
  rawData: string;
}

export interface MigrationStepResult {
  step: MigrationStep;
  status: StepStatus;
  recordsProcessed: number;
  recordsFailed: number;
  errors: MigrationError[];
  startedAt: string | null;
  completedAt: string | null;
}

export interface MigrationStatusResponse {
  migrationRunId: number | null;
  locationId: number;
  currentStep: MigrationStep;
  overallStatus: OverallStatus;
  steps: MigrationStepResult[];
  canRestart: boolean;
  startedAt: string | null;
  completedAt: string | null;
}

export const STEP_ORDER: MigrationStep[] = [
  MigrationStep.CUSTOMER,
  MigrationStep.TRUCKING_COMPANY,
  MigrationStep.BOOKING,
  MigrationStep.ACTIVE_UNIT,
  MigrationStep.CONTRACT,
  MigrationStep.REDELIVERY
];

export const STEP_LABELS: Record<MigrationStep, string> = {
  [MigrationStep.CUSTOMER]: 'Customer',
  [MigrationStep.TRUCKING_COMPANY]: 'Trucking Companies',
  [MigrationStep.BOOKING]: 'Bookings',
  [MigrationStep.ACTIVE_UNIT]: 'Active Units',
  [MigrationStep.CONTRACT]: 'Contracts',
  [MigrationStep.REDELIVERY]: 'Redeliveries'
};

export const OPTIONAL_STEPS: MigrationStep[] = [MigrationStep.TRUCKING_COMPANY];

export const STEP_DESCRIPTIONS: Record<MigrationStep, string> = {
  [MigrationStep.CUSTOMER]: 'Import customer records from CSV',
  [MigrationStep.TRUCKING_COMPANY]: 'Import trucking companies from CSV',
  [MigrationStep.BOOKING]: 'Import bookings with equipment details from CSV',
  [MigrationStep.ACTIVE_UNIT]: 'Import active gate-in transactions and units from CSV',
  [MigrationStep.CONTRACT]: 'Import customer contracts and rate schedules from CSV',
  [MigrationStep.REDELIVERY]: 'Import redelivery orders from CSV'
};
